import React, { useState } from "react";
import Chart from "react-apexcharts";

const ModelPerformanceChart = ({ data }) => {


  const [currentIndex, setCurrentIndex] = useState(data?.predicted_sales?.length);
  const entriesPerPage = 12;


  const currentDataSlice = (comingdata) => {
    if (!comingdata) return [];
    const startIndex = currentIndex % entriesPerPage === 0 ? Math.max(0, currentIndex - entriesPerPage) : Math.max(0, currentIndex - currentIndex % entriesPerPage);
    return comingdata.slice(startIndex, currentIndex);
  };

  const toggleDatanext = () => {
    const nextIndex = currentIndex % entriesPerPage === 0 ? currentIndex + entriesPerPage : currentIndex + data?.predicted_sales.length % entriesPerPage;
    console.log(nextIndex)
    setCurrentIndex(nextIndex);

  };
  const toggleDataprev = () => {
    const prevIndex = currentIndex % entriesPerPage === 0 ? currentIndex - entriesPerPage : currentIndex - currentIndex % entriesPerPage;
    console.log(prevIndex)

    if (prevIndex < entriesPerPage) {
      // Reset to start if we reach the end
      setCurrentIndex(prevIndex);
    } else {
      setCurrentIndex(prevIndex);
    }
  };

  const chartOptions =
  {
    chart: {
      id: `Download`,
      type: "line",
      toolbar: {
        show: true,
      },
    },
    grid: {
      show: false,
    },
    stroke: {
      width: 2,
    },
    title: {
      text: `Actual vs Predicted (${data.brand}-${data.market})`,
      align: "center",
    },
    colors: ["#4CAF50", "#FFC107"],
    dataLabels: {
      enabled: true,
      style: {
        fontSize: 11,
      },
      formatter: function (val) {
        return val;
      },
    },
    xaxis: {
      categories: currentDataSlice(data?.predicted_sales)?.map((it) => it.month_year),
      title: {
        text: "Month-Year",
        style: {
          color: "#FFC107",
        },
      },
      labels: {
        style: {
          fontSize: "14px",
        },
        formatter: function (val) {
          return val;
        },
      },
    },
    yaxis: [
      {
        seriesName: "Sales",
        opposite: false,
        min: 0,
        axisBorder: {
          show: true,
        },
        title: {
          text: "Sales Volume (Tonnes)",
          floating: true,
          style: {
            color: "#4CAF50",
          },
        },
        labels: {
          style: {
            fontSize: "14px",
          },
        },
      },
    ],
  };
  const plotdata = [
    {
      name: "Actual Sales",
      data: currentDataSlice(data?.actuals)?.map((item) => (item?.actuals / 1000).toFixed(2) || null)
    },
    {
      name: "Predicted Sales",
      data: currentDataSlice(data?.predicted_sales)?.map((item) => (item?.predicted_sales / 1000).toFixed(2) || null)
    }
  ];

  return (
    <div>
      <div className="">


        {/* Replace this with your chart rendering logic */}

        <Chart

          align="center"
          options={chartOptions}
          series={plotdata}
          height={400}
          width={'90%'}
        />


      </div>
      <div className="d-flex justify-content-between my-2">
        <button className={currentIndex - entriesPerPage <= 0 ? "btn btn-secondary" : "btngreentheme p-2"} onClick={() => { toggleDataprev() }} disabled={currentIndex - entriesPerPage <= 0}>Previous</button>
        <button className={currentIndex >= data?.predicted_sales?.length ? "btn btn-secondary" : "btngreentheme p-2"} onClick={() => { toggleDatanext() }} disabled={currentIndex >= data?.predicted_sales?.length}>Next</button>
      </div>

    </div>
  );
};

export default ModelPerformanceChart;
